import { render, staticRenderFns } from "./SectionKnobs.vue?vue&type=template&id=685ae34b&scoped=true"
import script from "./SectionKnobs.vue?vue&type=script&lang=js"
export * from "./SectionKnobs.vue?vue&type=script&lang=js"
import style0 from "./SectionKnobs.vue?vue&type=style&index=0&id=685ae34b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ae34b",
  null
  
)

export default component.exports